import {HASHED_EMAIL_KEY, pushDataLayer, sendHashedEmailEvent} from '@optimaxdev/analytics/mobile';

import {REACTPV_IMPRESSIONS} from 'constants/analytics/reactpv';
import {sendCommonAnalytics, getAnalyticsLocationInfo} from 'libs/analytics/setDimension';
import {localStore} from 'libs/storage/storage';

/**
 * Send page impression event.
 *
 * @param {string} type - Page type.
 */
export const sendReactPV = (type: string) => {
    const key = type ? type.toUpperCase() : type;

    const event =
        key in REACTPV_IMPRESSIONS ? REACTPV_IMPRESSIONS[key] : REACTPV_IMPRESSIONS.DEFAULT;

    sendCommonAnalytics();
    pushDataLayer({event, ...getAnalyticsLocationInfo()});
    if (localStore.get(HASHED_EMAIL_KEY))
        sendHashedEmailEvent(localStore.get(HASHED_EMAIL_KEY), {isAlreadyHashed: true});
};
